/* eslint-disable react/jsx-no-target-blank */
import {useAuth} from '../../../../../app/modules/auth'
import {SidebarMenuItem} from './SidebarMenuItem'

const SidebarMenuMain = () => {
  const {isSuperAdmin} = useAuth()

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      {/* {currentUser?.groups && (currentUser?.groups.includes('Admin') || currentUser?.groups.includes('Manager')) && <SidebarMenuItem to='/apps/stock-management/stock' icon='/media/icons/duotune/ecommerce/ecm004.svg' title='Stock Items' fontIcon='bi-layers' />}
      {currentUser?.groups && (currentUser?.groups.includes('Admin') || currentUser?.groups.includes('Clerk')) && <SidebarMenuItem to='/apps/job-management/jobs' icon='/media/icons/duotune/ecommerce/ecm006.svg' title='Jobs' fontIcon='bi-layers' />} */}

      <SidebarMenuItem to='/apps/stock-management/stock' icon='/media/icons/duotune/ecommerce/ecm004.svg' title='Stock Items' fontIcon='bi-layers' />
      {isSuperAdmin() && <SidebarMenuItem to='/apps/stock-management/categories' icon='/media/icons/duotune/abstract/abs027.svg' title='Stock Categories' fontIcon='bi-layers' />}
      <SidebarMenuItem to='/apps/job-management/jobs' icon='/media/icons/duotune/ecommerce/ecm006.svg' title='Jobs' fontIcon='bi-layers' />
    </>
  )
}

export {SidebarMenuMain}
